export default {
  zeusBlackUI: '#26221e',
  funGreen: '#008520',
  funGreenUI: '#00801f',
  funGreenUIHover: '#006619',
  flushOrange: '#ff8600',
  desertOrangeUI: '#b45d26',
  altoGray: '#d8d8d8',
  midGrayUI: '#565a69',
  midGrayUIHover: '#434651',
  opalGray: '#a4bdc4',
  wildSandGray: '#f6f6f6',
  simpleRed: '#e90a0a',
  brightRedUI: '#ae0000',
  brightRedUIHover: '#850000',
  confettiYellow: '#efD063',
  thunderbirdRedUI: '#d21313',
  doveGrayUI: '#6e6e6e',
  doveGrayUIHover: '#545454',
  twineBrown: '#c29d67',
  pigmentRedUI: '#f2221e',
  begoniaUI: '#F76F6D',
  jetGray: '#333333',
  flatBlackUI: '#111111',
  crayolaBlueUI: '#007edc',
  webGrayUI: '#7d7d7d',
  slimyGreenUI: '#049828',
  chathamsBlue: '#184868',
  ceruleanBlue: '#0095de',
  daintreeBlue: '#001b29',
  deepCeruleanBlueUIOpacity40: '#8fc7df',
  deepCeruleanBlueUI: '#0074ad',
  deepCeruleanBlueUIHover: '#00527a',
  waterlooGrayUI: '#7b8093',
  pictonBlueUIHover: '#59BAEA',
  taraweraBlue: '#0c4369',
  pistachioGreen: '#89bf00',
  camaroneGreenUI: '#006618',
  endeavourBlueUI: '#0065b1',
  endeavourBlueUIOpacity40: '#b2d1e8',
  endeavourBlueUIHover: '#00518F',
  emeraldUI: '#5CBC73',
  blueJeansUI: '#59ABE8',
  monzaRed: '#e90a0a',
  selectiveYellow: '#F9B000',
  flirtPinkUI: '#99037B',
  flirtPinkUIHover: '#73025C',
  shockingPinkUIHover: '#bc0497',
  clementineOrange: '#eb6702',
  rosePinkUI: '#F369D7',
  simpleGreen: '#16cf01',
  shockingPink: '#ff0db3',
  simpleBlueUI: '#001afd',
  simpleBlueUIHover: '#0014c2',
  hollywoodCeriseUI: '#d60093',
  hollywoodCeriseUIHover: '#ad0077',
  veryLightBlue: '#6176ff',
  electricGreen: '#00ff00',
  blue: '#0000ff',
  chineseBlack: '#181716',
  hotPinkUI: '#FB66CC',
  malibuUI: '#909FFF',
  atollUI: '#0B5A79',
  jellyBeanUI: '#2885a9',
  nileBlueUI: '#183D4D',
  duneBrown: '#36302f',
  millbrookBrownUI: '#645237',
  twineBrownUI: '#c29d67',
  leatherUI: '#856B47',
  tanUI: '#CEB185',
  milanoRedUI30: '#da1600',
  milanoRedUIHover30: '#b81c0a',
  milanoRedUIActive30: '#972114',
  lochmaraBlueUI30: '#0088ca',
  lochmaraBlueUIHover30: '#0078bc',
  lochmaraBlueUIActive30: '#046eb1',
  zeusBlackUI30: '#201c17',
  japaneseLaurelGreenUI30: '#008600',
  yellowGreen30: '#b8e986',
  dustyGray30: '#959595',
  abbeyGrayUI30: '#525455',
  alabasterGray30: '#fafafa',
  concreteGray30: '#f3f3f3',
  mercuryGray30: '#e4e4e4',
  red30: '#da1600',
  green30: '#008600',
  blue30: '#046eb1',
  yellow30: '#efd063',
  orange30: '#f39100',
  black30: '#201c17',
  white30: '#fff',
  midRed30: '#b81c0a',
  darkRed30: '#972114',
  lightGray30: '#fafafa',
  midGray30: '#959595',
  darkGray30: '#525455',
  darkestGray30: '#525447',
  brownishGray30: '#787878',
  platinum30: '#e4e4e4',
  silver30: '#f3f3f3',
  lightGreen30: '#b8e986',
  strongBlue30: '#0077bd',
  blueHighlight30: '#0078d7',
  logoOrange30: '#f39100',
  logoDarkRed30: '#cc0b18',
  logoBlue30: '#0077bd',
  logoGreen30: '#18a035',
  alternativeOrange30: '#d17d00'
};